import { useState, useCallback, memo, useEffect, useRef } from "react";
import { Services } from "../network/Services";
import { capitalizeFirstLetter, formatDateLocal, formatDateLocalPST, formatDateByZone,getTodayDateUSFormat } from "../control/Constant";
import { getFormattedUTCDateForCE } from "../network/helper";


const RefundCard = memo(({ data, onAccept, onReject, subtenantId }) => {
  // console.log(data?.accountType,"datadatadatadatadata1111")
  let accountType = data?.accountType != null ? JSON?.parse(data?.accountType)[0]?.AccountTypeId : null
  let accountTypeName = accountType == 1 ? 'General' : accountType == 2 ? 'IOLTA' : '-'
  
  // Check if this is Federal Way Plaza
  const isFederalWayPlaza = subtenantId == 989 || subtenantId == 760;
  
  // Extract unit number from notes for Federal Way Plaza
  let unitNumber = '-';
  let displayNotes = data?.notes || '-';
  
  if (isFederalWayPlaza && data?.notes) {
    const unitMatch = data.notes.match(/Unit:\s*([^|]+)/);
    if (unitMatch) {
      unitNumber = unitMatch[1].trim();
      // Remove unit info from display notes
      displayNotes = data.notes.replace(/Unit:\s*[^|]+\s*\|\s*/, '').replace(/Unit:\s*[^|]+$/, '').trim() || '-';
    }
  }
  
  // Fallback to other fields if unit number not found in notes
  if (unitNumber === '-' && isFederalWayPlaza) {
    unitNumber = data?.seriveMatNo || data?.matterNo || data?.orderDetailsVMs?.[0]?.unitNumber || '-';
  }
  
  return (
    <div className="p-3 bg-gray-100 rounded text-sm space-y-1">
      <p className="font-semibold">{data.title}</p>
      
      {isFederalWayPlaza ? (
        <>
          <p>Tenant Name: {capitalizeFirstLetter(data.tenantName || data.clientName || data.requestByName)}</p>
          <p>Unit Number: {unitNumber}</p>
        </>
      ) : subtenantId == 3 ? (
        <>
          <p>Client: {capitalizeFirstLetter(data.clientName)}</p>
          <p>Client Email: {data.clientEmail}</p>
        </>
      ) : (
        <>
          <p>Client: {capitalizeFirstLetter(data.clientName)}</p>
          <p>Client Email: {data.clientEmail}</p>
          <p>Mat No: {data?.seriveMatNo}</p>
        </>
      )}
      
      <p>Service: {data?.productName}</p>
      {/* <p>Refund Type: {data.totalCost == data.refundBasedTotalCost ? 'Full' : 'Partial'}</p> */}
      <p>Total Paid: ${data.refundBasedTotalCost}</p>
      {!isFederalWayPlaza && <p>Account Type: {accountTypeName}</p>}
      <p>Refunded Amount: ${data.totalRefundCost}</p>
      <p className="font-medium text-red-600">
        Refund Requested: ${data.totalCost}
      </p>
      <p>Refund Requested by: {capitalizeFirstLetter(data?.requestByName)}</p>
      <p>Refund Method: {data?.refundPaymentType}</p>
      <p>Note: {displayNotes}</p>
      <p>Date: {formatDateByZone(data.createdOn)}</p>
      <p>Status: {data.statusName}</p>


      {data?.statusId == 1 && <div className="flex gap-2 mt-3">
        <button
          onClick={() => onAccept(data)}
          className="w-full py-1 bg-green-500 text-white rounded hover:bg-green-600"
        >
          Accept
        </button>

        <button
          onClick={() => onReject(data)}
          className="w-full py-1 bg-gray-300 rounded hover:bg-gray-400"
        >
          Reject
        </button>
      </div>}
    </div>
  );
});

const  CancelSubsCard  = memo(({ data,handleAcceptSubs, handleRejectSubs}) => {
  return (
    <div className="p-3 bg-gray-100 rounded text-sm space-y-1">
      <p className="font-semibold">{data?.subscriptionName}</p>
      <p>Client: {capitalizeFirstLetter(data?.clientName)}</p>
      <p >installment Amount: <span className="font-medium text-red-600">${data?.installmentAmount}</span></p> 
      <p>Cancellation Type: {(data?.isSubsCancel==true)?"Complete Subscription":"Upcoming Scheduled Payment"}</p> 
      {data?.statusId != 1 && <p>Status: <span className={`${(data?.statusId==2)?"font-medium text-green-600":"font-medium text-red-600"}`}>{(data.statusId==2)?"Accepted":"Declined"}</span></p> }
      {data?.statusId == 1 && <div className="flex gap-2 mt-3">
        <button onClick={() => handleAcceptSubs(data)} className="w-full py-1 bg-green-500 text-white rounded hover:bg-green-600" >Accept</button>
        <button onClick={() => handleRejectSubs(data)} className="w-full py-1 bg-gray-300 rounded hover:bg-gray-400" > Reject </button>
      </div>}
    </div>
  );
});

export default function RefundNotification({setuseLoader,setToast,onRefundUpdate}) {
  const [open, setOpen] = useState(false);
  const [notifyArray,setNotifyarray] = useState([])
  const [loggedInUserId,setLoggedInUserId] = useState(sessionStorage?.getItem('loggedUserId'))
  const [subtenantId,setsubtenantId] = useState(sessionStorage?.getItem('SubtenantId'))
  const [pageNumber,setPageNumber] = useState(1)
  const scrollContainerRef = useRef(null);
  const loadMoreRef = useRef(null);
  const [showRefunds,setShowRefunds]=useState(true)
  const [cancelSubArray,setCancelSubArray]=useState([])
  const [hasUpdates, setHasUpdates] = useState(false)

  // useEffect(()=>{
  //   setNotifyarray([])
  //   setPageNumber(1)
  // },[open])

  useEffect(()=>{
    if(open == true){
    getRefundrequestfunc()
    setShowRefunds(true)}
  },[open])

  useEffect(()=>{
    if(showRefunds==false){
      GetModifySubsRequest()
    }
  },[showRefunds])

  

  const GetModifySubsRequest = async () => {
    let json = {
    "subtenantId":subtenantId || 742,
    }
    try{
      setuseLoader(true)
      let subSReqResp = await Services.GetModifySubsRequest(json)
      
      if(subSReqResp != 'err'){
          setCancelSubArray(subSReqResp?.data?.data || []);
          setuseLoader(false)
      }
    }
    catch(err){
      setuseLoader(false)
    }
   
  }

  //  const GetModifySubsRequest = async () => {
  //   let json = {
  //   "subtenantId":subtenantId || 742,
  //   }
  //   // try{
  //     setuseLoader(true)
  //     let subSReqResp = await Services.GetModifySubsRequest(json)
     
  //     if(subSReqResp != 'err'){
  //         setCancelSubArray(subSReqResp?.data?.data || []);
  //         setuseLoader(false)
  //     }
  //   // }
  //   // catch(err){
  //   //   setuseLoader(false)
  //   // }
   
  // }
 

  console.log("vfdcs",cancelSubArray)

  const getRefundrequestfunc = async () => {
    let json = {
    "isActive": true,
    "subtenantId":subtenantId || 742,
    // "statusId":1,
    // "pageNumber":pageNumber,
    // "rowsOfPage":40
    }
    setuseLoader(true)
    let getRefundrequestresponse = await Services.getRefundrequestService(json)
    setuseLoader(false)
    if(getRefundrequestresponse != 'err'){
      console.log(getRefundrequestresponse,"getRefundrequestresponse")
        setNotifyarray(getRefundrequestresponse?.data?.data);
    }
  }

useEffect(() => {
  if (!loadMoreRef.current || !scrollContainerRef.current) return;

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        setPageNumber(prev => prev + 1);
      }
    },
    {
      root: scrollContainerRef.current, // 🔥 REQUIRED
      rootMargin: "100px",
      threshold: 0,
    }
  );

  observer.observe(loadMoreRef.current);

  return () => observer.disconnect();
}, []);



  const handleAccept = useCallback(async(data) => {
    await updateRefundPaymentFunc(data)
  }, []);

  const handleReject = useCallback(async (data) => {

    await updateRefundrequestFunc(data,3)
  }, []);

  const handleAcceptSubs = useCallback(async(data) => {
    await UpdateAcceptSubs(data,2)
  }, []);

  const handleRejectSubs = useCallback(async (data) => {

    await UpdateRejectSubs(data,3)
  }, []);

  const updateRefundrequestFunc = async (data,status) => {
    let jsonObj = [{
      "refReqId": data?.refReqId,
      "statusId": status,
      "accpetBy": loggedInUserId,
      "isActive": true
    }]
    console.log(data,"datadata",status)
    setuseLoader(true)
    let updateRefundrequestparams = await Services?.updateRefundrequestService(jsonObj);
    setuseLoader(false)
    if(updateRefundrequestparams != 'err'){
      console.log(updateRefundrequestparams,"updateRefundrequestparams")
      setToast({ message: `Refund request is ${status == 2 ? 'accepted' : 'declined'} successfully.`, type: "success" });
      setHasUpdates(true); // Mark that updates occurred
      if(status == 3){
      getRefundrequestfunc();
      }
    }
  }



  const updateOrderFunc = async (data) => {
    let jsonObj = {
      "orderId": data?.refundOrderId,
      "isRefund": true,
      "isActive": true,
      "updatedBy": loggedInUserId
    }
    console.log(data,"datadata")
    setuseLoader(true)
    let updateOrderparams = await Services?.updateOrderService(jsonObj);
    setuseLoader(false)
    if(updateOrderparams != 'err'){
      console.log(updateOrderparams,"updateRefundrequestparams")
      getRefundrequestfunc();
    }
  }

  const updateRefundPaymentFunc = async (data) => {
    let jsonObj = {
      "userId": data?.user_id,
      "orderId": data?.refundOrderId,
      "refReqId": data?.refReqId,
      "acceptedBy": loggedInUserId,
      "accountTypeId": JSON.parse(data?.accountType)[0]?.AccountTypeId,
      "subtenantId": subtenantId,
      "statusId":2
    }

    // console.log(data,"datadata")
    setuseLoader(true)
    let updateOrderparams = await Services?.updateRefundPaymentService(jsonObj);
    setuseLoader(false)
    if(updateOrderparams != 'err'){
      setToast({ message: `Refund request is accepted successfully.`, type: "success" });
      setHasUpdates(true); // Mark that updates occurred
      getRefundrequestfunc();
    }
   }

   const UpdateAcceptSubs = async (data,status) => {
    let jsonObj = {
      modSubReqId: data?.modSubReqId, 
      statusId: 2,
      updatedBy:loggedInUserId
    }
 
    setuseLoader(true)
    let ApiResponse = await Services?.UpdateModifySubsRequest(jsonObj);
    setuseLoader(false)
    if(ApiResponse != 'err'){
      setToast({ message: `Cancellation request accepted successfully.`, type: "success" });
      setHasUpdates(true); // Mark that updates occurred
      GetModifySubsRequest();
    }
   }

   const UpdateRejectSubs = async (data,status) => {
    let jsonObj = {
      modSubReqId: data?.modSubReqId, 
      statusId: 3,
      updatedBy:loggedInUserId
    }
 
    setuseLoader(true)
    let ApiResponse = await Services?.UpdateModifySubsRequest(jsonObj);
    setuseLoader(false)
    if(ApiResponse != 'err'){
      setToast({ message: `Cancellation request declined successfully.`, type: "success" });
      setHasUpdates(true); // Mark that updates occurred
      GetModifySubsRequest();
    }
   }


  console.log(notifyArray,"notifyArray")

  return (
    <>
      {/* Button */}
      <button
        onClick={() => setOpen(true)}
        className="bg-[#720c20] text-white px-3 py-2 rounded shadow hover:bg-[#720c20]"
      >
        Refund/ Cancel Requests
      </button>

      {/* Overlay */}
      {/* {open && (
        <div
          onClick={() => setOpen(false)}
          className="fixed inset-0 bg-black/40 z-0"
        />
      )} */}

      {/* Side Panel */}
      <div
        className={`fixed top-0 right-0 h-full w-[70vh] bg-white shadow-lg z-10
        transform transition-transform duration-300
        ${open ? "translate-x-0" : "translate-x-full"}`}
      >
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b">
          <div>
            <button class="bg-green-500 text-white px-3 py-2 rounded shadow " onClick={()=>setShowRefunds(true)}>Refund Requests</button>
            {/* Hide Cancel Requests button for subtenants 3, 989, and 760 */}
            {subtenantId != 3 && subtenantId != 989 && subtenantId != 760 && (
              <button class=" ml-2 bg-[#720c20] text-white px-3 py-2 rounded shadow " onClick={()=>setShowRefunds(false)}>Cancel Requests</button>
            )}
          </div>
          <button
            onClick={() => {
              setOpen(false);
              // Trigger refresh if there were any updates
              if (hasUpdates && onRefundUpdate) {
                onRefundUpdate();
              }
              setHasUpdates(false);
            }}
            className="text-gray-500 hover:text-black text-xl"
          >
            ×
          </button>
        </div>

        {/* List */}
        {showRefunds==true?<>
          <div className="p-4 space-y-3 overflow-y-auto h-[calc(100%-64px)]" ref={scrollContainerRef}>
          <p className="font-semibold mb-2">Pending Requests:</p>
          {notifyArray.length === 0 ? (
            <p className="text-gray-500 text-sm text-center">
              No pending refund requests
            </p>
          ) : (
            notifyArray?.sort((a,b)=> new Date(b.createdOn) - new Date(a.createdOn))?.map((note) => (
              <RefundCard
                key={note.refReqId}
                data={note}
                onAccept={handleAccept}
                onReject={handleReject}
                subtenantId={subtenantId}
              />
            ))
          )}
            <div ref={loadMoreRef} style={{ height: 1 }} />
        </div>
        </>:
        <div className="p-4 space-y-3 overflow-y-auto h-[calc(100%-64px)]" ref={scrollContainerRef}>
        <p className="font-semibold mb-2">Cancel Requests:</p>
        {cancelSubArray.length === 0 ? (
          <p className="text-gray-500 text-sm text-center">
            No Cancel requests found
          </p>
        ) : (
          cancelSubArray?.sort((a,b)=> new Date(b.createdOn) - new Date(a.createdOn))?.map((subsData) => (
            <CancelSubsCard
              // key={note.refReqId}
              data={subsData}
              handleAcceptSubs={handleAcceptSubs}
              handleRejectSubs={handleRejectSubs}
            />
          ))
        )}
          {/* <div ref={loadMoreRef} style={{ height: 1 }} /> */}
      </div>
        }
        
      </div>
    </>
  );
}
